import { useEffect, useMemo, useState } from "react";
import { isLoggedIn } from "api/coachAuth";
import { ProgramType } from "data/programData";
import useFetch from "./useFetch";
import { useRecoilValue } from "recoil";
import { userAtom } from "recoil/userAtom";
import useGetBlankTaskData, {
  setDataWithEditorKeyAndTranslationVersion,
} from "./useGetBlankTaskData";
import { getLastShownIndex, getTaskIdFromTaskKey } from "logic/logics";

export default function useGetTaskData({ taskKey }: { taskKey: string }) {
  const [data, setData] = useState<ProgramType>();
  const user = useRecoilValue(userAtom);
  // task editor v2 → 운영 어댑터는 폐기됨. v1 흐름만 사용.
  // 향후 어댑터로 다시 들어올 경우 isTaskEditorTask 분기 복구.
  const isTaskEditorTask = false;
  void getTaskIdFromTaskKey;

  // useEffect(() => {
  //   console.log("GET TASK DATA", taskKey);
  // }, [taskKey]);

  const blankTaskData = useGetBlankTaskData({ taskKey: taskKey });
  const fetchRequest = useMemo(
    () => ({
      url: "/task/data/load",
      params: { tk: taskKey },
    }),
    [taskKey]
  );

  const [fetchedData, getData] = useFetch(fetchRequest);

  useEffect(() => {
    if (blankTaskData) {
      if (isLoggedIn(user) && !taskKey.includes("Tool") && !isTaskEditorTask) {
        getData();
      } else {
        setData(blankTaskData);
      }
    }
  }, [
    blankTaskData,
    getData,
    isTaskEditorTask,
    taskKey,
    user?.accessToken,
    user?.authMode,
  ]);

  useEffect(() => {
    if (fetchedData) {
      const totalData = fetchedData?.result.data;
      if (
        totalData &&
        totalData.content.length > 0 &&
        !(
          taskKey.split("-")[0] === "104" &&
          getLastShownIndex(totalData.content) === 0
        )
      ) {
        console.log("FETCH: ", totalData);
        setData(setDataWithEditorKeyAndTranslationVersion(totalData));
      } else {
        setData(blankTaskData);
      }
    }
  }, [fetchedData]);

  return {
    data,
    refetch: () => {
      if (isLoggedIn(user) && !taskKey.includes("Tool") && !isTaskEditorTask) {
        getData();
      }
    },
  };
}
